import { defineAsyncComponent } from 'vue'
export default {
  empty: defineAsyncComponent(() => import("/home/ploi/nmodata.nl/front-end/layouts/empty.vue").then(m => m.default || m)),
  management: defineAsyncComponent(() => import("/home/ploi/nmodata.nl/front-end/layouts/management.vue").then(m => m.default || m)),
  public: defineAsyncComponent(() => import("/home/ploi/nmodata.nl/front-end/layouts/public.vue").then(m => m.default || m))
}